/*
 * @Author: 杨秦 yangqin@horsevision.cn
 * @Date: 2026-04-07 09:10:46
 * @LastEditors: 杨秦 yangqin@horsevision.cn
 * @LastEditTime: 2026-04-20 13:43:04
 * @FilePath: \yongan-investor-edu\src\router\remoteControlRoutes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteRecordRaw } from "vue-router";
import remoteControlView from "@/views/remoteControl/remoteControlView.vue";

export const remoteControlRoutes: Array<RouteRecordRaw> = [
  {
    path: "/remoteControl",
    name: "remoteControl",
    component: remoteControlView,
    children: [
      //基地大屏控制器
      {
        path: "baseControl",
        name: "BaseControl",
        component: () =>
          // 投教成果小屏首页
          import(
            /* webpackChunkName: "about" */
            "@/views/remoteControl/baseControl/BaseControl.vue"
          ),
      }
    ],
  },
];
